import { useEffect, useState } from 'react'

export const useMobileScreen = (): boolean => {
  const [mobileView, setMobileView] = useState<boolean>(false)

  useEffect(() => {
    setTimeout(() => setMobileView(window.screen.width <= 690), 0)
  }, [])

  return mobileView
}
